// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__ksJSn","wrapper":"Checkbox_wrapper__DgqGw","input":"Checkbox_input__QNxAP","icon":"Checkbox_icon__PaXgX","true":"Checkbox_true__djS7z"};